/**
 * TanStack Query hooks for public payment routes.
 *
 * usePublicInvoice: fetch once, cache for the session.
 *
 * Note: usePaymentSession (for /pay/success polling) ships in the follow-up PR.
 */

import { useQuery } from '@tanstack/react-query';
import { getPublicInvoice } from '@/services/publicPayApi';

export function usePublicInvoice(token: string) {
  return useQuery({
    queryKey: ['public-invoice', token],
    queryFn: () => getPublicInvoice(token),
    enabled: !!token,
    staleTime: Infinity, // invoice data doesn't change mid-session
    retry: false, // server errors (404/expired) are terminal — don't retry
  });
}
